// 引入公共函数
import * as publicMethods from './../../../shared/utils/publicMethods';

export class WsMessage {
  /**
   * 消息的标题
   */
  public tital: string;
  /**
   * 作者
   */
  public sender: string;
  /**
   * 消息
   */
  public message: string;
  /**
   * 消息详情的id
   */
  public contentId: string;
  /**
   * 发送类型
   */
  public pushType: string;
  /**
   * 消息类型。同时也是流程业务类型id
   */
  public typeCode: string;

  constructor(data: any) {
    this.tital = publicMethods.setNullStr(data.tital);
    this.sender = publicMethods.setNullStr(data.sender);
    this.message = publicMethods.setNullStr(data.message);
    this.contentId = publicMethods.setNullStr(data.contentId);
    this.pushType = publicMethods.setNullStr(data.pushType);
    this.typeCode = publicMethods.setNullStr(data.typeCode);
  }
}
